module.exports = __webpack_public_path__ + "img/my-age.e5ae16a6.png";